/**
 * Shared user profile query configuration
 * Use this to ensure consistent query parameters across client and server
 */
import type {
  UserControllerGetProfileQueryParams,
  UserControllerGetProfileQueryParamsIncludeEnumKey,
} from "@dc/gateway-jsonapi";

export const USER_PROFILE_QUERY_PARAMS: UserControllerGetProfileQueryParams = {
  include: "principal.roles.role,preferences" as UserControllerGetProfileQueryParamsIncludeEnumKey,
};
